// Facade over the bilingual explanation texts: `explain(key)` returns the copy
// in the active dashboard language, falling back to German, then to "" so a
// missing key renders nothing rather than a raw id. `explanations` keeps the
// German map under its historical name.

import { lang, type Lang } from "@/i18n";
import { explanationsDe, explanationsEn } from "@/i18n/explanations";

const DICTS: Record<Lang, Record<string, string>> = {
  de: explanationsDe,
  en: explanationsEn,
};

export const explanations = explanationsDe;

export function explain(key: string): string {
  return DICTS[lang.value][key] ?? DICTS.de[key] ?? "";
}

export type ExplanationKey = keyof typeof explanationsDe;
